var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PuttyKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CMqx7oK2kxn3siFMuwzaFa",
    x1: 22.94,
    x2: 27.725,
    y1: 6.474,
    y2: 24.879,
    gradientTransform: "rotate(180 24 26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CMqx7oK2kxn3siFMuwzaFa)",
    d: "M24,18L24,18c5.289,0,9.9,3.6,11.183,8.731l3.314,15.86C38.756,43.833,37.808,45,36.539,45 H11.461c-1.269,0-2.217-1.167-1.958-2.409l3.314-15.86C14.1,21.6,18.711,18,24,18z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CMqx7oK2kxn3siFMuwzaFb",
    x1: 24,
    x2: 24,
    y1: -2.514,
    y2: 10.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ea2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CMqx7oK2kxn3siFMuwzaFb)",
    d: "M24,2c-2.761,0-5,2.239-5,5c0,0.657,0.718,10.062,1.211,13.693 C20.468,22.589,22.086,24,24,24s3.532-1.411,3.789-3.307C28.282,17.062,29,7.657,29,7C29,4.239,26.761,2,24,2z M24,9 c-1.105,0-2-0.896-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C26,8.104,25.105,9,24,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PuttyKnife);
export default __webpack_public_path__ + "static/media/icons8-putty-knife.2b6d1d79ca66c3e6110ec58afb72d3ce.svg";
export { ForwardRef as ReactComponent };